import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export class DateCell extends GridCell {

  public render() {
    return <td>
      <div>
        {this.props.dataItem[this.props.field] && this.props.dataItem[this.props.field].format('YYYY-MM-DD')}
      </div>
    </td>
  }

}



// WEBPACK FOOTER //
// ./src/pages/content-calendar/render/date_cell.tsx